import { Capability } from './types';
export function defineCapability(definition) {
  return new Capability(definition);
}